let _accessToken = '';

export const setAccessToken = (token: string): void => {
  _accessToken = token;
};

export const getAccessToken = (): string => _accessToken;
